module.exports = __webpack_public_path__ + "static/media/pouting-cat-svgrepo-com.7943dacb.svg";